import { makeChartComp } from '../../util/makeChartComp';
var HeatmapChart = makeChartComp('Heatmap');
export default HeatmapChart;
